import { render, staticRenderFns } from "./step-card.vue?vue&type=template&id=3fc6c5cc&scoped=true"
import script from "./step-card.vue?vue&type=script&lang=js"
export * from "./step-card.vue?vue&type=script&lang=js"
import style0 from "./step-card.vue?vue&type=style&index=0&id=3fc6c5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6c5cc",
  null
  
)

export default component.exports